<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

html,
body {
  padding: 0;
  margin: 0;
  overflow: hidden;
}

ul {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}

* {
  box-sizing: border-box;
}

/*滚动条样式 */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: var(--el-color-primary);
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: transparent;
}

/*列表页和单开详情页共用 */
.list-box {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 10px;
  position: relative;

  .nav {
    display: flex;
    align-items: center;

    &::before {
      content: attr(data-title);
      flex: 1;
      font-weight: bold;
      margin-left: 10px;
      white-space: nowrap;
    }

    & > .el-input {
      width: 300px !important;
    }
  }

  .search {
    position: relative;
    border: 1px solid #ebeef5;
    border-bottom: 0;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    & > .item {
      position: relative;
      min-width: 250px;
      &::before {
        position: absolute;
        content: attr(data-title);
        color: #a2a2a2;
        top: -20px;
        background-color: #fff;
        padding: 0 5px;
        font-size: 12px;
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}

/*自定义列表标题 */
.c-table-col-header {
  float: left;
  &::before {
    content: attr(label1);
  }

  &::after {
    content: "/" attr(label2); /*attr内容拼接直接用空格，无需加号 */
    font-size: 80%;
    color: #a2a2a2;
  }
}

.info-box {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;

  & > .submit-box {
    margin-top: 10px;
    text-align: right;
  }
}

.number-input-left {
  .el-input__inner {
    text-align: left !important;
  }
}

.number-input-suffix {
  position: relative;

  .el-input__inner {
    text-align: left !important;
  }

  &::after {
    content: attr(suffix);
    border-left: var(--el-border);
    display: flex;
    align-items: center;
    font-size: 12px;
    background-color: #f5f7fa;
    padding: 0 10px;
    position: absolute;
    right: 1px;
    top: 1px;
    height: calc(100% - 2px);
    color: var(--el-color-info);
    border-top-right-radius: var(--el-border-radius-base);
    border-bottom-right-radius: var(--el-border-radius-base);
  }

  .el-input__wrapper {
    padding-right: 44px !important;
    padding-left: 10px !important;
  }
}

/*表格中的数字输入框，设置加减按钮宽度，减少列宽 */
.tab-input-number {
  .el-input-number__decrease,
  .el-input-number__increase {
    width: 20px !important;
  }

  .el-input__wrapper {
    padding-left: 5px !important;
    padding-right: 25px !important;
  }
}

.el-overlay-dialog,
.el-modal-dialog {
  position: absolute !important;
}

.c-el-dialog {
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  & > .el-dialog__header {
    font-weight: 600;
    --el-dialog-title-font-size: 14px;

    &::after {
      content: "长按鼠标左键可拖动窗口";
      position: absolute;
      right: 50px;
      top: 15px;
      height: 10px;
      color: #fb923c;
      font-size: 11px;
      font-weight: 500;
    }
  }

  & > .el-dialog__body {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}

/**负责人下拉树组件样式 */
.belonger-tree-class {
  --el-tree-node-content-height: 40px !important;

  & .el-select-dropdown__item {
    display: flex;
    align-items: center;
    height: 40px !important;
    line-height: 40px !important;
  }
}

.c-icon-trigon-r {
  width: 0;
  height: 0;
  border-bottom: calc(var(--size, 8) * 0.4px) solid transparent;
  border-top: calc(var(--size, 8) * 0.4px) solid transparent;
  border-left: calc(var(--size, 8) * 0.5px) solid #1e90ff;
}

//el-tabs组件，panel高度自适应
.c-el-tabs-auto-height {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  & > .el-tabs__header {
    margin: 0 !important;
  }

  & > .el-tabs__content {
    flex: 1;
    & > .el-tab-pane {
      height: 100%;
    }
  }
}

.c-segmented {
  --el-border-radius-base: 30px;
  --el-segmented-padding: 5px !important;
}

.c-delete-dialog {
  /* --el-messagebox-title-color: var(--el-color-danger) !important; */
  --el-messagebox-font-size: 14px !important;
}

.c-search-white {
  --el-input-bg-color: #fff;
  --el-input-border-color: #fff;
  --el-border-radius-base: 8px;
}

.el-button {
  --el-border-radius-base: 8px;
  --el-font-size-base: 12px;
}

//输入框清空图标与后缀图标调换位置，调到后缀图标前面，固定后缀图标位置，便于列表页搜索框搜索
.el-input {
  .el-input__suffix-inner {
    display: flex;
    flex-direction: row-reverse !important; /* 核心：左右反转 */
  }
}

.el-upload-dragger {
  padding: 0 !important;
}

.el-upload-dragger.is-dragover {
  padding: inherit !important;
  background-color: #f6f6f6 !important;
  border: inherit !important;
}

.select-mui-collapse {
  .el-select__selection {
    flex-wrap: nowrap !important;
    overflow: hidden !important;
  }
}

.c-el-form-item-label {
  .el-form-item__label {
    display: flex !important;
  }
}

.table-btn-clear-margin {
  & .el-button + .el-button {
    margin-left: 0 !important;
  }
}

/* 需要深度选择器 */
.no-arrow-input input::-webkit-outer-spin-button,
.no-arrow-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
